import * as React from "react";
import { Grid } from "@material-ui/core";

import { NumberField } from "./NumberField";

export interface IProps {
    readonly widthStr: string;
    readonly heightStr: string;

    readonly width: number;
    readonly height: number;

    readonly widthMin?: number;
    readonly widthMax?: number;

    readonly heightMin?: number;
    readonly heightMax?: number;

    readonly isInteger?: boolean;

    readonly onChanged: (w: number, h: number) => void;
}

export function SizeField(props: IProps): React.ReactElement {
    const onWidthChanged = (value: number) => props.onChanged(value, props.height);
    const onHeightChanged = (value: number) => props.onChanged(props.width, value);

    return (
        <Grid container direction="row" spacing={1}>
            <Grid item xs>
                <NumberField
                    label={props.widthStr}
                    min={props.widthMin}
                    max={props.widthMax}
                    value={props.width} 
                    isInteger={props.isInteger}
                    onChanged={onWidthChanged} />
            </Grid>
            
            <Grid item xs>
                <NumberField
                    label={props.heightStr}
                    min={props.heightMin}
                    max={props.heightMax}
                    value={props.height} 
                    isInteger={props.isInteger}
                    onChanged={onHeightChanged} />
            </Grid>
        </Grid>
    )
}